import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Остались вопросы?',
  description: 'Финансовый менеджер поле.рф проконсультирует вас по всем вопросам',
  button: 'Получить консультацию',
} satisfies TMessages
